"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/col/style/css");

var _col = _interopRequireDefault(require("antd/es/col"));

require("antd/es/row/style/css");

var _row = _interopRequireDefault(require("antd/es/row"));

require("antd/es/spin/style/css");

var _spin = _interopRequireDefault(require("antd/es/spin"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/typography/style/css");

var _typography = _interopRequireDefault(require("antd/es/typography"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _topic = require("../../../../redux/topics/topic.types");

var _reselect = require("reselect");

var selectors = _interopRequireWildcard(require("../../../../redux/selectors"));

var _TopicDetail = _interopRequireDefault(require("../../resource/topic/TopicDetail"));

var _icons = require("@ant-design/icons");

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _topicService = _interopRequireDefault(require("../../../../service/knowledgeCenter/topicService"));

var _TopicConstant = require("../../../../constant/TopicConstant");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Text,
  Title
} = _typography.default;
const droppableId = "droppable";

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  // change background colour if dragging
  background: isDragging ? "lightblue" : undefined,
  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightyellow" : undefined
});

const TopicManagement = props => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const [topicSelected, setTopicSelected] = (0, _react.useState)();
  const [tmpTopicSelected, setTmpTopicSelected] = (0, _react.useState)();
  const [resourceTopics, setResourceTopics] = (0, _react.useState)();
  const [hasChange, setHasChange] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [showDiscardChangeConfirm, setShowDiscardChangeConfirm] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    // get topics
    if (!props.topics) {
      dispatch(_topic.loadGoalTopicsAsync.request());
    }
  }, []);
  (0, _react.useEffect)(() => {
    setResourceTopics(props.topics);
  }, [props.topics]);

  const addNewTopic = parentTopic => {
    const topicCollectionId = _TopicConstant.TopicCollectionIds.GOAL;
    let sortOrder = 1;

    if (parentTopic && parentTopic.children && parentTopic.children.length > 0) {
      const len = parentTopic.children.length - 1;
      const sortOrderLast = parentTopic.children[len].sortOrder;
      sortOrder = sortOrderLast !== null && sortOrderLast !== void 0 ? sortOrderLast : 1;
    }

    const newTopic = {
      parentTopicId: parentTopic === null || parentTopic === void 0 ? void 0 : parentTopic.id,
      topicCollectionId: topicCollectionId,
      sortOrder: sortOrder
    };
    setTopicSelected(newTopic);
  };

  const getTopicRow = (topic, index, level = 0) => {
    let selectedStyle = {};

    if (topic.id === (topicSelected === null || topicSelected === void 0 ? void 0 : topicSelected.id)) {
      selectedStyle = {
        fontBold: "bold",
        backgroundColor: "#FEF3BD",
        borderRadius: 6
      };
    }

    return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
      key: topic.id,
      draggableId: topic.id.toString(),
      index: index
    }, (provided, snapshot) => /*#__PURE__*/_react.default.createElement("div", Object.assign({
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps, {
      style: getItemStyle(snapshot.isDragging, provided.draggableProps.style)
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginLeft: 15 * level,
        marginBottom: 5,
        paddingRight: 10,
        cursor: "pointer",
        ...selectedStyle
      },
      onClick: () => selectTopic(topic)
    }, /*#__PURE__*/_react.default.createElement(Text, {
      style: {
        padding: 3
      },
      title: level > 0 ? `Used: ${topic.articleCount}` : ""
    }, topic.title), !!topic.backgroundImageUri && /*#__PURE__*/_react.default.createElement(_icons.FileImageOutlined, {
      style: {
        fontSize: 12
      }
    })), level === 0 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      shape: "round",
      icon: /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null),
      size: "small",
      onClick: () => addNewTopic(topic)
    }, "Subtopic"))), /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
      onDragEnd: onDragEnd
    }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
      droppableId: `${droppableId}-${topic.id}`
    }, (provided, snapshot) => /*#__PURE__*/_react.default.createElement("div", Object.assign({}, provided.droppableProps, {
      ref: provided.innerRef,
      style: getListStyle(snapshot.isDraggingOver)
    }), topic.children && topic.children.map((child, index) => {
      return getTopicRow(child, index, level + 1);
    }), provided.placeholder)))));
  };

  const selectTopic = topic => {
    if (hasChange) {
      setTmpTopicSelected(topic);
      setShowDiscardChangeConfirm(true);
    } else {
      setTopicSelected(topic);
    }
  };

  const handleDiscardChange = () => {
    setShowDiscardChangeConfirm(false);
    setTopicSelected(tmpTopicSelected);
    setHasChange(false);
  };

  const handleDiscardCancel = () => {
    setShowDiscardChangeConfirm(false);
    setHasChange(false);
  };

  const onChange = (hasChange = true) => {
    setHasChange(hasChange);
  };

  const onDragEnd = async result => {
    var _a;

    try {
      // dropped outside the list
      if (!result.destination) {
        return;
      }

      setIsLoading(true);

      if (props.topics) {
        let existingTopics = [];
        const sourceIndex = result.source.index;
        const destIndex = result.destination.index;

        if (result.destination && result.destination.droppableId === droppableId) {
          // top level reorder
          existingTopics = props.topics.map(topic => {
            return {
              id: topic.id,
              sortOrder: topic.sortOrder
            };
          }); // update topic stored in state so UI will show correct order

          if (resourceTopics) {
            const tmpResourceTopic = [...resourceTopics];
            const [removed] = tmpResourceTopic.splice(sourceIndex, 1);
            tmpResourceTopic.splice(destIndex, 0, removed);
            setResourceTopics(tmpResourceTopic);
          }
        } else if (result.destination && result.destination.droppableId.startsWith(droppableId + "-")) {
          const parentTargetId = result.destination.droppableId.replace(droppableId + "-", "");
          const topicChildren = (_a = props.topics.find(topic => topic.id === parseInt(parentTargetId))) === null || _a === void 0 ? void 0 : _a.children;

          if (topicChildren) {
            topicChildren.forEach(childTopic => {
              existingTopics.push({
                id: childTopic.id,
                sortOrder: childTopic.sortOrder
              });
            });
            const tmpTopicChildren = [...topicChildren];
            const [removed] = tmpTopicChildren.splice(sourceIndex, 1);
            tmpTopicChildren.splice(destIndex, 0, removed);
            const tmpResourceTopic = resourceTopics === null || resourceTopics === void 0 ? void 0 : resourceTopics.map(topic => {
              if (topic.id === parseInt(parentTargetId)) {
                return { ...topic,
                  children: tmpTopicChildren
                };
              }

              return topic;
            });
            setResourceTopics(tmpResourceTopic);
          }
        }

        if (existingTopics && existingTopics.length > 0) {
          await reorderSubmit(existingTopics, sourceIndex, destIndex);
        }
      }
    } catch (err) {
      console.error(err);

      _message2.default.error("Error in updating sort", err);
    } finally {
      setIsLoading(false);
    }
  };

  const reorderSubmit = async (topics, sourceIndex, destIndex) => {
    if (topics) {
      const [removed] = topics.splice(sourceIndex, 1);
      topics.splice(destIndex, 0, removed);
      const updatedTopLevel = topics.map((topic, index) => {
        return {
          id: topic.id,
          sortOrder: index + 1
        };
      }); // call api to update the sort order

      await _topicService.default.updateSort(updatedTopLevel);
      props.loadGoalTopics();
    }
  };

  const onDelete = () => {
    setTopicSelected(undefined);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_card.default, {
    title: /*#__PURE__*/_react.default.createElement("div", {
      className: "resources-title"
    }, /*#__PURE__*/_react.default.createElement("h1", null, "Topics"), /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: () => addNewTopic()
    }, "+ Add Topic"))
  }, !resourceTopics && /*#__PURE__*/_react.default.createElement(_spin.default, null), resourceTopics && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 8
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: isLoading
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundColor: "#eeeeee",
      height: "calc(100vh - 300px)",
      overflow: "auto",
      padding: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: droppableId
  }, (provided, snapshot) => /*#__PURE__*/_react.default.createElement("div", Object.assign({}, provided.droppableProps, {
    ref: provided.innerRef,
    style: getListStyle(snapshot.isDraggingOver)
  }), resourceTopics === null || resourceTopics === void 0 ? void 0 : resourceTopics.map((topic, index) => {
    return getTopicRow(topic, index);
  }), provided.placeholder)))))), /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 16
  }, /*#__PURE__*/_react.default.createElement(_TopicDetail.default, {
    topic: topicSelected,
    onChange: onChange,
    onDelete: onDelete
  }))))), /*#__PURE__*/_react.default.createElement(_modal.default, {
    title: "Unsaved Changes",
    visible: showDiscardChangeConfirm,
    onOk: handleDiscardChange,
    onCancel: handleDiscardCancel
  }, /*#__PURE__*/_react.default.createElement("p", null, "There are some unsaved changes. Are you sure you want to proceed?")));
};

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  topics: selectors.getGoalTopics
});

const mapDispatchToProps = dispatch => {
  return {
    loadGoalTopics: () => dispatch(_topic.loadGoalTopicsAsync.request())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TopicManagement);

exports.default = _default;